import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {environment as env} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OrderonlineServiceService {

  constructor(private http:HttpClient) { } 

  orderOnlineBanner(bannerlocation:string){
    return this.http.get<any>(env.apiurl+'get-banner/'+bannerlocation, {})
      .pipe(map(homeBanner => {
        if (homeBanner) {            
          return homeBanner;
        }
      }),
    );
  }

  addTowishlist(pid, uid){
    return this.http.post(env.apiurl+'add-wishlist', {
      productid:pid, 
      userid:uid
    }).pipe(rawData => {return rawData;});
  }

  rmWishlist(pid, uid){
    return this.http.post(env.apiurl+'remove-wishlist-product', {
      productid:pid, 
      userid:uid
    }).pipe(rawData => {return rawData;});
  }

  
}
